import React, { useRef, useState } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { Download } from 'lucide-react';

const PDFHeader = ({ member }) => (
  <div style={{ textAlign: 'center', borderBottom: '3px solid #D4AF37', paddingBottom: '15px', marginBottom: '20px' }}>
    <h1 style={{ fontSize: '36px', fontWeight: '900', margin: '0 0 5px 0', letterSpacing: '2px', color: '#05140D', textTransform: 'uppercase' }}>
      SVT GOLDEN FITNESS
    </h1>
    <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
      SVT AA VENTURES PVT. LTD.
    </p>
    <p style={{ margin: '0 0 15px 0', fontSize: '12px', color: '#555' }}>
      No 26/7, 2nd floor, Jawaharlal Nehru rd, BEML layout 3rd stage,<br/>
      Rajarajeshwari Nagar, Bengaluru - 560098. Mob : 81237 65171
    </p>
    
    <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '5px', border: '1px solid #eee' }}>
      <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
        MEMBER NO: <span style={{ fontWeight: 'normal', color: '#D4AF37' }}>{member.id?.split('-')[0].substring(0,8).toUpperCase()}</span>
      </div>
      <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
        DATE: <span style={{ fontWeight: 'normal' }}>{member.join_date}</span>
      </div>
    </div>
  </div>
);

const SectionTitle = ({ title }) => (
  <h2 style={{ 
    fontSize: '16px', 
    fontWeight: 'bold', 
    backgroundColor: '#05140D', 
    color: '#D4AF37', 
    padding: '8px 12px', 
    margin: '20px 0 10px 0',
    textTransform: 'uppercase',
    letterSpacing: '1px'
  }}>
    {title}
  </h2>
);

const DataRow = ({ label1, value1, label2, value2 }) => (
  <div style={{ display: 'flex', borderBottom: '1px solid #eee', padding: '8px 0', fontSize: '13px' }}>
    <div style={{ flex: 1, display: 'flex' }}>
      <strong style={{ width: '140px', color: '#555' }}>{label1}:</strong>
      <span style={{ flex: 1, color: '#000', fontWeight: '500' }}>{value1 || '-'}</span>
    </div>
    {label2 && (
      <div style={{ flex: 1, display: 'flex' }}>
        <strong style={{ width: '140px', color: '#555' }}>{label2}:</strong>
        <span style={{ flex: 1, color: '#000', fontWeight: '500' }}>{value2 || '-'}</span>
      </div>
    )}
  </div>
);

const PDFDemographics = ({ member }) => (
  <div>
    <SectionTitle title="Personal Details" />
    <DataRow label1="Full Name" value1={member.name} label2="Gender" value2={member.gender} />
    <DataRow label1="Date of Birth" value1={member.dob} label2="Age" value2={member.age} />
    <DataRow label1="Cell Phone" value1={member.phone || member.cellPhone} label2="Home Phone" value2={member.homePhone} />
    <DataRow label1="Email Address" value1={member.email} label2="Company" value2={member.company} />
    <div style={{ display: 'flex', borderBottom: '1px solid #eee', padding: '8px 0', fontSize: '13px' }}>
      <strong style={{ width: '140px', color: '#555' }}>Residential Address:</strong>
      <span style={{ flex: 1, color: '#000', fontWeight: '500' }}>{member.address || '-'}</span>
    </div>

    <SectionTitle title="Physical & Emergency Details" />
    <DataRow label1="Height (cm)" value1={member.height} label2="Weight (kg)" value2={member.weight} />
    <DataRow label1="BMI" value1={member.bmi} label2="Blood Group" value2="-" />
    <DataRow label1="Emergency Contact" value1={member.emergency_name} label2="Emergency Phone" value2={member.emergency_phone} />

    <SectionTitle title="Membership Details" />
    <DataRow label1="Selected Package" value1={member.package} label2="Start Date" value2={member.join_date} />
    <div style={{ display: 'flex', borderBottom: '1px solid #eee', padding: '8px 0', fontSize: '13px' }}>
      <strong style={{ width: '140px', color: '#555' }}>Heard About Us:</strong>
      <span style={{ flex: 1, color: '#000', fontWeight: '500' }}>{member.heard_about || '-'}</span>
    </div>
  </div>
);

const PDFAgreement = () => (
  <div style={{ marginTop: '25px' }}>
    <SectionTitle title="Membership Privileges, Notices, Disclosure & Agreement" />
    <div style={{ fontSize: '10px', textAlign: 'justify', lineHeight: '1.6', color: '#333', backgroundColor: '#fcfcfc', padding: '15px', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
      <p style={{ margin: '0 0 8px 0' }}>This form is valid for the entire duration of membership periods as stated above, including upgrades & renewals. Any change of address, etc., must be notified to the gym on a separate form and will be updated in the system accordingly.</p>
      
      <p style={{ margin: '0 0 8px 0' }}><strong>Activation of membership:</strong> The membership is automatically activated the next day as per the date of payment of membership fees unless specified by the member on sign up and date duly filled in the 'Starting date' section. The club cannot hold a membership 'Starting Date' for more than 60 days.</p>
      
      <p style={{ margin: '0 0 8px 0' }}><strong>Upgrading / Renewal:</strong> Any change in membership program/upgradation has to be done within 15 days of joining. The program can be interchanged only once. A member gets a renewal package only on completion of a yearly membership. A fresh membership can be taken on completion of the earlier package. Enrollment fee does not need to be paid again.</p>
      
      <p style={{ margin: '0 0 8px 0' }}><strong>Transfer & Freezing:</strong> The membership is transferrable to another individual. A cheque with the refund amount for remaining days will be made. The member can freeze their membership anytime for a maximum of 15 days.</p>
      
      <p style={{ margin: '0 0 8px 0' }}><strong>Cancellation / Refunds:</strong> No refunds shall be made for membership dues paid, except if by reason of death or permanent disability, the member is unable to use the services or facilities of the club. In case the club is closed or shut down by the management, the management will refund the money on a pro-rata basis to the member for the unused period of the contract.</p>
      
      <p style={{ margin: '0 0 8px 0' }}><strong>Waiver & Release of liability:</strong> This membership agreement contains a waiver & release of liability and Indemnity agreement to which you will be bound. Do not sign this agreement before you read it. By signing below you acknowledge receipt of a fully completed copy of this membership agreement executed by you and the club.</p>
      
      <p style={{ margin: '0', color: '#000', fontWeight: 'bold' }}>Declaration: You are aware of the risk to the musculoskeletal system if exercises are not done in proper form, and risk to the cardio-respiratory system (dizziness, discomfort in breathing, heart attacks). You declare that you are in a physically sound state of health and are not suffering from any conditions, impairment, disease, infirmity, or other illness that would prevent your participation or use of equipment or machinery in this Gym. You also give consent to the trainer having to touch you during spotting or carrying out certain exercise moves.</p>
    </div>
  </div>
);

const PDFSignatures = ({ member }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '60px', padding: '0 20px' }}>
    <div style={{ width: '35%', borderTop: '2px solid #05140D', paddingTop: '10px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold' }}>
      Authorised Fitness Consultant
    </div>
    <div style={{ width: '40%', borderTop: '2px solid #05140D', paddingTop: '10px', position: 'relative', textAlign: 'center', fontSize: '14px', fontWeight: 'bold' }}>
      {member.signature && (
        <img 
          src={member.signature} 
          alt="Signature" 
          style={{ 
            position: 'absolute', 
            bottom: '35px', 
            left: '50%', 
            transform: 'translateX(-50%)', 
            height: '80px', 
            width: 'auto',
            mixBlendMode: 'multiply' 
          }} 
        />
      )}
      Member Signature
    </div>
  </div>
);

export default function MemberPDFButton({ member }) {
  const printRef = useRef();
  const [isGenerating, setIsGenerating] = useState(false);

  const handleDownloadPdf = async (e) => {
    e.stopPropagation();
    setIsGenerating(true);
    const element = printRef.current;
    
    // Make visible for html2canvas to render properly
    element.style.display = 'block';

    try {
      // Small delay allows the browser DOM (and base64 image src) to update rendering after changing to display: block
      await new Promise(resolve => setTimeout(resolve, 500));

      const canvas = await html2canvas(element, { 
        scale: 2, 
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false
      });
      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${member.name.replace(/\s+/g, '_')}_SVT_Agreement.pdf`);
    } catch(err) {
      console.error(err);
    } finally {
      element.style.display = 'none';
      setIsGenerating(false);
    }
  };

  return (
    <>
      <button 
        onClick={handleDownloadPdf} 
        disabled={isGenerating}
        className="flex items-center gap-1 bg-white text-primary border border-primary/50 px-3 py-1 rounded text-xs hover:bg-primary/20 transition-colors"
      >
        <Download size={14}/> {isGenerating ? "Generating..." : "Download Form"}
      </button>

      {/* Hidden PDF Template Container */}
      <div style={{ position: 'absolute', left: '-9999px', top: '0', pointerEvents: 'none' }}>
        <div 
          ref={printRef} 
          style={{ 
            display: 'none', 
            width: '210mm', 
            minHeight: '297mm', 
            padding: '15mm 20mm', 
            backgroundColor: '#ffffff', 
            color: '#000000', 
            fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', 
            boxSizing: 'border-box'
          }}
        >
          <PDFHeader member={member} />
          <PDFDemographics member={member} />
          <PDFAgreement />
          <PDFSignatures member={member} />
        </div>
      </div>
    </>
  );
}
